export const RESOURCES_HUB_TEXT_PAGE = 'resources';

export const getResourceDocumentTextPage = (slug) => `resources-${slug}`;

export const getResourceDocumentTextGroup = (id) => `doc-${id}`;

export const RESOURCE_REQUEST_FORM_TEXT_GROUP = 'request-form';

export const RESOURCE_UNSUBSCRIBE_TEXT_GROUP = 'unsubscribe';
